import { SmIcon } from '@smiles/smiles-react-design-system';
import React from 'react';
import type { TabTypes } from '../../../../types';

export interface ITabProps {
  label: string;
  type: TabTypes;
  isActive: boolean;
  onTabClick: (type: TabTypes) => void;
}

export const Tab = ({ label, type, isActive, onTabClick, ...props }: ITabProps) => {
  const handleTabClick = () => {
    onTabClick(type);
  };

  return (
    <section
      className={`car-search-mobile-header-tabbed-tab-container ${type}${isActive ? ' active' : ''}`}
      onClick={handleTabClick}
      {...props}
    >
      <article className="car-search-mobile-header-tabbed-tab-label-wrapper">
        <SmIcon
          className="car-search-mobile-header-tabbed-tab-label-icon"
          name={type === 'pickup' ? 'arrow_forward' : 'arrow_back'}
          type="round"
        />
        <span className="car-search-mobile-header-tabbed-tab-label-text">{label}</span>
      </article>

      <div className="car-serach-mobile-header-tabbed-tab-indicator" />
    </section>
  );
};
